import React, { useState, useEffect } from 'react';
import api from '../lib/api';
import { UserProfile } from '../types/api';

const Profile = () => {
    const [profile, setProfile] = useState<UserProfile | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const response = await api.get('/users/profile');
                setProfile(response.data);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchProfile();
    }, []);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 via-secondary-50 to-accent-50">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-primary-500"></div>
            </div>
        );
    }

    if (!profile) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 via-secondary-50 to-accent-50">
                <div className="text-xl text-gray-600">Nepodařilo se načíst profil.</div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-primary-50 via-secondary-50 to-accent-50 p-4 sm:p-6 lg:p-8">
            <div className="max-w-4xl mx-auto">
                <div className="text-center mb-8 sm:mb-12">
                    <h2 className="text-4xl sm:text-5xl font-bold bg-gradient-to-r from-primary-600 to-secondary-600 bg-clip-text text-transparent mb-2">
                        Můj Profil
                    </h2>
                    <p className="text-gray-600">Vaše statistiky a osobní údaje</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                    <div className="bg-white/80 backdrop-blur-lg p-6 rounded-3xl shadow-card border border-white">
                        <div className="text-3xl font-bold text-gray-900">{profile.wins}</div>
                        <div className="text-sm text-gray-600 mt-1">Výhry</div>
                    </div>
                    <div className="bg-white/80 backdrop-blur-lg p-6 rounded-3xl shadow-card border border-white">
                        <div className="text-3xl font-bold text-gray-900">{profile.goalsScored}</div>
                        <div className="text-sm text-gray-600 mt-1">Vstřelené góly</div>
                    </div>
                    <div className="bg-white/80 backdrop-blur-lg p-6 rounded-3xl shadow-card border border-white">
                        <div className="text-3xl font-bold text-gray-900">{profile.winRate}%</div>
                        <div className="text-sm text-gray-600 mt-1">Úspěšnost</div>
                    </div>
                </div>

                <div className="bg-white/80 backdrop-blur-lg p-8 rounded-3xl shadow-card border border-white">
                    <h3 className="text-2xl font-bold text-gray-900 mb-6">Osobní údaje</h3>
                    <div className="space-y-4">
                        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
                            <span className="text-gray-600">Jméno</span>
                            <span className="font-bold text-gray-900">{profile.name || 'Nenastaveno'}</span>
                        </div>
                        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
                            <span className="text-gray-600">E-mail</span>
                            <span className="font-bold text-gray-900">{profile.email}</span>
                        </div>
                        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
                            <span className="text-gray-600">Členem od</span>
                            <span className="font-bold text-gray-900">{new Date(profile.createdAt).toLocaleDateString()}</span>
                        </div>
                    </div>
                </div>

                <div className="mt-8 bg-white/80 backdrop-blur-lg p-8 rounded-3xl shadow-card border border-white">
                    <h3 className="text-2xl font-bold text-gray-900 mb-6">Statistiky zápasů</h3>
                    <div className="grid grid-cols-2 gap-4">
                        <div className="p-4 bg-green-50 rounded-xl text-center">
                            <div className="text-2xl font-bold text-green-700">{profile.matchesPlayed}</div>
                            <div className="text-sm text-green-600">Odehrané zápasy</div>
                        </div>
                        <div className="p-4 bg-red-50 rounded-xl text-center">
                            <div className="text-2xl font-bold text-red-700">{profile.losses}</div>
                            <div className="text-sm text-red-600">Prohry</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profile;
